<main>
  <nav>
    <button class="card-button" mat-flat-button color="accent" mat-dialog-close>{{'close' | translation}}</button>
  </nav>
  <h1> Le contenu doit être au format HTML ou texte uniquement </h1>
  <h2>Voici les balise géré par l'email:</h2>

  <div id="instructions">
    <p><strong>[QUESTION-INDEX]:</strong> affichera la réponse a la question correspondant à l'index.<br />Pour trouver ce dernier, merci de vous référé a l'index affiché directement dans le questionnaire'(ex: [QUESTION-0] affichera la réponse a la 1ère question)</p>
      <img src="assets/img/tuto/tuto-email-index.png"/>

    <p><strong>[PRIZE]:</strong> affichera le lot gagné, utilisera le nom enregistré dans le lot</p>
</div>
  <h2>Exemple:</h2>
  <div class="exampleContainter">
    <div id="code">
      <pre [textContent]="htmlCode" style="background: #f4f4f4; padding: 10px;"></pre>
    </div>
    <div id="exemple">
      <div id="emailExampleContent">
        <!DOCTYPE html>
        <html lang="fr">
        <head>
          <meta charset="UTF-8">
          <title>Félicitations !</title>
        </head>
        <body style="font-family: Arial, sans-serif; color: #333333; line-height: 1.6;">

          <div style="text-align: center;">
            <img src="[Logo_Boutique]" alt="Logo Boutique" style="max-width: 200px;" />
          </div>

          <div style="text-align: center; margin: 20px 0;">
            <img src="[Image_Entête]" alt="Image Entête" style="width: 100%; max-width: 600px;" />
          </div>

          <p>Bonjour <strong>test@example.com</strong>,</p>

          <h2 style="color: #4CAF50;">🎁 Félicitations !</h2>

          <p>Grâce à ton achat réalisé en magasin, tu as gagné <strong>Lot n°1</strong>.</p>

          <p>Va le récupérer à l'accueil avec ce mail.</p>

          <p>Cordialement.</p>

          <div style="text-align: center; margin-top: 30px;">
            <img src="[Image_Pied-de-mail]" alt="Pied de mail" style="width: 100%; max-width: 600px;" />
          </div>

        </body>
      </html>
      </div>
    </div>

  </div>


</main>
